// Public surface of the ArcDisk demo integration. Everything Mosaico proper
// touches is imported from here (routes.tsx, ArcProjectsPage.tsx); nothing
// outside src/arcdisk imports deeper paths, so removing or relocating the
// folder later is a matter of deleting these few call sites.
export { useArcDiskDemoEnabled, useArcDiskDemoLoading } from './useArcDiskDemo'
export { isDemoProjectCardId, withDemoProjects } from './data/projects'
export { demoStudentDiscPath, isDemoStudentCardId, withDemoStudents } from './data/students'
export { ArcDiskProjectRouteGate } from './pages/ArcDiskProjectRouteGate'
export { ArcDiskStudentPage } from './pages/ArcDiskStudentPage'
